
































import { Component } from 'vue-property-decorator';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import { OpportunityDetailsModule } from '@/store/modules/opportunityDetails';
import { AppModule } from '@/store/modules/app';
import OpportunityStage, { OpportunityStageLabels } from '@/models/Opportunities/OpportunityStage';
import OpportunityStageSetLost from '@/components/Opportunities/OpportunityStageSetLost.vue';

@Component({
  name: 'OpportunityStageSet',
  components: { OpportunityStageSetLost },
})
export default class extends GiganautVueDialog {
  menu = false;

  get opportunity() { return OpportunityDetailsModule.opportunity; }

  // Lost gets its own dialog (captures reason); the others are direct list items.
  // The three intermediate stages are hidden when the agency has disabled them
  // via AgencySettings (surfaced on currentAgencyContext).
  get openStageOptions() {
    const ctx = AppModule.currentAgencyContext;
    const options: { value: number; label: string }[] = [
      { value: OpportunityStage.New, label: OpportunityStageLabels[OpportunityStage.New] },
    ];
    if (!ctx || ctx.showOpportunityStageQualified !== false) {
      options.push({ value: OpportunityStage.Qualified, label: OpportunityStageLabels[OpportunityStage.Qualified] });
    }
    if (!ctx || ctx.showOpportunityStageProposing !== false) {
      options.push({ value: OpportunityStage.Proposing, label: OpportunityStageLabels[OpportunityStage.Proposing] });
    }
    if (!ctx || ctx.showOpportunityStageNegotiating !== false) {
      options.push({ value: OpportunityStage.Negotiating, label: OpportunityStageLabels[OpportunityStage.Negotiating] });
    }
    options.push({ value: OpportunityStage.Won, label: OpportunityStageLabels[OpportunityStage.Won] });
    return options;
  }

  // Picking "Won" no longer fires UpdateStage directly — it opens the Convert
  // wizard, which calls POST /convert (and the backend ensures stage=Won and
  // stamps the won audit fields as part of the conversion transaction). Other
  // stages still go through the simple stage-update flow.
  async onStagePicked(stage: OpportunityStage) {
    if (!this.opportunity) return;
    if (stage === OpportunityStage.Won) {
      // Reveal the inline Convert-to-Won wizard (replaces the detail tabs).
      OpportunityDetailsModule.setShowConvertWizard(true);
      return;
    }
    await OpportunityDetailsModule.setStage({
      id: this.opportunity.id,
      stage,
      updatedAt: this.opportunity.updatedAt,
    });
  }
}
